import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let fm = {
    get: field => state => state[field],
    set: field => (state, val) => state[field] = val,
}

let generatorFn = function(key) {
    let res = {}
    let kn = key == 'get' ? 'get' : 'set'
    Object.keys(state).forEach(item =>
         res[ kn + item[0].toUpperCase() + item.substring(1) ] = fm[kn](item))
    return res
}



let state = {
    indexData: '',
    joinUsData: '',
    useEnglish: false,
    lang: localStorage.getItem('langType') || 'zh',
}



export default new Vuex.Store({
    state,
    mutations: generatorFn('set'),
    getters: generatorFn('get'),
})
    


// WEBPACK FOOTER //
// ./src/store/index.js